// extracted by mini-css-extract-plugin
export default {"convention":"ConventionCreator_convention__XAea6","hideBorder":"ConventionCreator_hideBorder__7StDL","errorText":"ConventionCreator_errorText__aqBgo"};